import { usersApi } from "@/services/api/user.api";
import appSnackbarService from "@/services/appSnackbar.service";
import i18n from "@/services/i18n";
interface UserPost {
  data: object;
  index: number;
}
interface UserDelete {
  id: number;
  index: number;
}

interface UserRequest {
  sortBy: string;
  descending: string;
  page: number;
  rowsPerPage: number;
}

interface UserPasswordPost {
  userId: string;
  password: string;
}

export const usersState: any = {
  namespaced: false,
  state: {
    users: [],
    totalUserItem: 0,
    loading: true,
    fetching: false,
    usernames: [],
  },
  mutations: {
    // load users
    USERS_FETCH_SUCCESS(state: any, payload: any) {
      state.users = payload.data;
      state.totalUserItem = payload.totalCount;
      state.loading = false;
    },
    USERS_FETCH_START(state: any) {
      state.fetching = true;
      state.loading = true;
    },
    USERS_FETCH_ERROR(state: any, payload: any) {
      state.fetching = false;
      state.error = payload;
      state.loading = false;
    },

    // save user
    USER_SAVE_SUCCESS(state: any, payload: any) {
      // either add or... update
      if (payload.index > -1) {
        // update
        // letörli a (payload.index)-ű elemet
        state.users.splice(payload.index, 1, payload.data);
        // és betölti a data elemet
        // state.users[payload.index] = payload.data;
      } else {
        // add
        state.users.push(payload.data);
      }
    },
    USER_SAVE_START(state: any) {
      state.fetching = true;
    },
    USER_SAVE_ERROR(state: any, payload: any) {
      state.fetching = false;
      state.error = payload.error;
    },
    USER_DELETE_SUCCESS(state: any, payload: any) {
      if (payload.index > -1) {
        // update
        state.users.splice(payload.index, 1);
        state.loading = false;
      }
    },
    USER_DELETE_START(state: any) {
      state.fetching = true;
      state.loading = true;
    },
    USER_DELETE_ERROR(state: any, payload: any) {
      state.fetching = false;
      state.error = payload;
      state.loading = false;
    },

    USER_NAMES_FETCH_SUCCESS(state: any, payload: any) {
      state.usernames = payload.data;
    },
    USER_NAMES_FETCH_START(state: any) {
      state.fetching = true;
    },
    USER_NAMES_FETCH_ERROR(state: any, payload: any) {
      state.fetching = false;
      state.error = payload;
    },
    USER_PASSWORD_SET_START(state: any) {
      state.fetching = true;
      state.loading = true;
    },
    USER_PASSWORD_SET_SUCCESS(state: any, payload: any) {
      state.fetching = false;
      state.loading = false;
    },
    USER_PASSWORD_ERROR(state: any, payload: any) {
      state.fetching = false;
      state.error = payload;
      state.loading = false;
    }
  },
  actions: {
    getUsers({ commit }: any, request: UserRequest) {
      commit("USERS_FETCH_START");
      usersApi
        .getAll(request)
        .then(response => {
          commit("USERS_FETCH_SUCCESS", response.data);
        })
        .catch(error => {
          commit("USERS_FETCH_ERROR", error);
        });
    },
    saveUser({ commit }: any, payload: UserPost) {
      commit("USER_SAVE_START");

      const editedIndex = payload.index;
      const promise = new Promise((resolve, reject) => {
      usersApi
        .save(payload)
        .then(response => {
          commit("USER_SAVE_SUCCESS", {
            data: response.data,
            index: editedIndex
          });
          appSnackbarService.success(i18n.t("SUCCESS_MESSAGES.USER_ADDED"));
          resolve(response);
        })
        .catch(error => {
          commit("USER_SAVE_ERROR", error);
          reject(error);
        });
      });
      return promise;
    },
    deleteUser({ commit }: any, payload: UserDelete) {
      commit("USER_DELETE_START");

      const deletedIndex = payload.index;
      usersApi
        .delete(payload.id)
        .then(response => {
          commit("USER_DELETE_SUCCESS", {
            data: response.data,
            index: deletedIndex
          });
          appSnackbarService.warning(i18n.t("SUCCESS_MESSAGES.USER_DELETED"));
        })
        .catch(error => {
          commit("USER_DELETE_ERROR", error);
        });
    },
    getUserNames({ commit }: any) {
      commit("USER_NAMES_FETCH_START");
      usersApi
        .getUserNames()
        .then(response => {
          commit("USER_NAMES_FETCH_SUCCESS", response.data);
        })
        .catch(error => {
          commit("USER_NAMES_FETCH_ERROR", error);
        });
    },
    saveNewPassword({ commit }: any, payload: UserPasswordPost) {
      commit("USER_PASSWORD_SET_START");

      console.log(payload);

      const promise = new Promise((resolve, reject) => {
      usersApi
        .setNewPassword(payload)
        .then(response => {
          commit("USER_PASSWORD_SET_SUCCESS");
          appSnackbarService.success(i18n.t("SUCCESS_MESSAGES.USER_PASSWORD_SET"));
          resolve(response);
        })
        .catch(error => {
          commit("USER_PASSWORD_ERROR", error);
          reject(error);
        });
      });
      return promise;
    },

  },
  getters: {}
};
